// import { PROVIDER_COURSES_GET_MANY } from '../new/course';
import {
  BUSY_INDICATOR,
  CHANGE_ORDER,
  LOGOUT,
  NOTIFICATION,
  PRODUCT_S3,
  PRODUCT_VIDEO_DELETE,
  PRODUCT_VIDEOS_GET_MANY,
  PRODUCTS_GET_MANY,
  PRODUCTS_SECTIONS_GET_MANY,
  PROVIDER_DELETE_BREAKS,
  PROVIDER_GET_ONETIME,
} from '../types';

import { Action } from './Action';
import { ActionStatus } from './ActionStatus';
import { buildActionType } from './buildActionType';
import { FailedNotification, SuccessNotification } from './Notification';
import { NotificationType } from './NotificationType';

const conditionalActions = ({ dispatch, action, response }) => {
  let serviceType = {};
  // if (response.type && response.type === 'Y') {
  //   serviceType = PROVIDER_COURSES_GET_MANY;
  // }
  // if (response.type && response.type === 'E') {
  //   serviceType = PROVIDER_EVENTS_GET_MANY;
  // }
  if (response.type && response.type === 'N') {
    serviceType = PROVIDER_GET_ONETIME;
  }
  if (response.type && response.type === 'P') {
    serviceType = PRODUCTS_GET_MANY;
  }

  switch (action) {
    case CHANGE_ORDER:
      return dispatch({ type: buildActionType(serviceType, ActionStatus.UPDATE), newArr: response.data });

    case PRODUCT_S3:
      return dispatch({ type: buildActionType(PRODUCTS_SECTIONS_GET_MANY, ActionStatus.INCREASE), index: response.data.sectionIndex });
    case PRODUCT_VIDEO_DELETE:
      return dispatch({ type: buildActionType(PRODUCTS_SECTIONS_GET_MANY, ActionStatus.DECREASE), index: response.data.sectionIndex });
    default:
      return null;
  }
};

const customMessageActions = ({ dispatch, action, customMessage, response }) => {
  if (action === PRODUCT_VIDEOS_GET_MANY && !response.result) {
    dispatch({
      type: NOTIFICATION,
      payload: { message: customMessage, variant: NotificationType.Warning },
    });
  } else {
    if (action === PRODUCT_VIDEOS_GET_MANY) {
      dispatch({
        type: NOTIFICATION,
        payload: { message: SuccessNotification[`${action.action}`], variant: NotificationType.Success },
      });
    } else {
      dispatch({ type: NOTIFICATION, payload: { message: customMessage, variant: NotificationType.Success } });
    }
  }
};

const executeApiCall =
  (apiCallExecution, action, silent = false, customMessage = false, noMessage = false) =>
  async dispatch => {
    const dispatchActions = {};
    const addDispatch = (action, status = '', props = {}) => {
      const type = buildActionType(action, status);
      dispatchActions[type] = dispatch({ type, ...props });
    };

    if (!silent) {
      addDispatch(action, ActionStatus.START);
      addDispatch(BUSY_INDICATOR, ActionStatus.START);
    }
    const response = await apiCallExecution;

    if (response.success) {
      addDispatch(action, ActionStatus.DONE, { payload: response.data, report: response.report });
      conditionalActions({ dispatch, response, action });

      if (customMessage) {
        customMessageActions({ dispatch, action, customMessage, response });
      } else if (!noMessage) {
        addDispatch(NOTIFICATION, '', {
          payload: { message: response.message || SuccessNotification[`${action.action}`], variant: NotificationType.Success },
        });
      }
    } else {
      addDispatch(action, ActionStatus.FAILED);
      if (action !== PROVIDER_DELETE_BREAKS) {
        if (!noMessage) {
          addDispatch(NOTIFICATION, '', {
            payload: { message: response.errors[0]?.message || FailedNotification[`${action.action}`], variant: NotificationType.Error },
          });
        }
      }
    }

    if (response.status === 401) {
      addDispatch(LOGOUT);
    }
    if (!silent) {
      addDispatch(BUSY_INDICATOR, ActionStatus.DONE);
    }
    return dispatchActions;
  };

const dispatchApiCall = (action, dispatch) => (err, d, res) => {
  if (!res || !res.body) {
    dispatch({
      type: buildActionType(action, ActionStatus.FAILED),
    });
  } else {
    const {
      body: { data, options },
    } = res;
    if (options) {
      dispatch({
        type: buildActionType({ entity: action.entity, action: Action.SET_OPTIONS }),
        payload: options,
      });
    }
    if (data) {
      dispatch({
        type: buildActionType(action, ActionStatus.DONE),
        payload: data,
      });
    } else {
      dispatch({
        type: buildActionType(action, ActionStatus.FAILED),
      });
    }
  }
};

export { dispatchApiCall, executeApiCall };
